const ja = {
  common: {
    loading: "読み込み中...",
    close: "閉じる",
    submit: "送信",
    review: "確認",
    help: "ヘルプ",
    tour: "ツアー",
    instructions: "説明",
    language: "言語",
    ok: "オーケ",
    appLoaderText:
      "読み込み中... アセスメント環境を準備していますので、しばらくお待ちください。"
  },
  assessment: {
    fetchError: "{{featureName}}の取得中にエラーが発生しました",
    somethingWentWrong: "問題が発生しました。",
    goBackToDashboard: "ダッシュボードに戻る",
    confirmSubmissionTitle: "提出の確認",
    scheduleIdNotFound: "Schedule Idが見つかりません",
    ongoingIdNotFound: "Ongoing Idが見つかりません",
    errorFetchingOngoingData: "進行中データの取得中にエラーが発生しました",
    connectionRestoredLabel: "接続が復旧しました。",
    connectionRestoredDescription: "テストケースの実行を続けられます。",
    connectionLostLabel: "テストサーバーへの接続が失われました。",
    connectionLostDescription: "現在はテストケースの実行や検証ができません。",
    featureNames: {
      assessment: "アセスメント",
      knowledgeCheck: "知識確認"
    },
    cardStatus: {
      na: "該当なし",
      toBeLaunched: "開始前",
      expired: "期限切れ",
      expiringSoon: "まもなく期限切れ",
      ongoing: "進行中"
    },
    cardState: {
      draft: "下書き",
      published: "公開済み",
      cancelled: "キャンセル済み",
      inreview: "レビュー中",
      readytopublish: "公開準備完了",
      sentback: "差し戻し"
    },
    dashboard: {
      videoProctoring: "ビデオ監督",
      submitFeature: "{{featureName}}を送信",
      noSectionsFound: "セクションが見つかりません",
      expandAllSections: "すべてのセクションを展開",
      closeAllSections: "すべてのセクションを閉じる",
      continueShapingAssessments: "アセスメントの作成を続けましょう",
      viewAll: "すべて表示",
      legend: {
        notStarted: "未開始",
        inProgress: "進行中",
        completed: "完了"
      }
    },
    confirmModal: {
      description:
        "送信後は{{featureName}}を変更できません。確認前に回答を見直してください。送信を続行しますか？",
      lowWordCountWarning:
        "質問{{questionTitle}}の回答は40語未満です。今送信するとこの回答は保存されません。",
      videoNotSubmittedWarning:
        "質問{{questionTitle}}の録画動画は未送信です。今送信するとこの回答は破棄されます。",
      unansweredQuestions: "未回答の質問が{{count}}件あります",
      andFlaggedQuestions: "フラグ付きの質問が{{count}}件あります",
      failedToFinish: "{{featureName}}の終了に失敗しました"
    },
    feedback: {
      submittedTitle: "{{featureName}}は正常に送信されました！",
      submittedDescription:
        "回答は送信されました。{{featureName}}の完了にご協力いただきありがとうございます。",
      resultInProgress:
        "結果を計算中です。最大1分ほどかかる場合があります。しばらくお待ちください。",
      resultReady: "結果の準備ができました。結果を表示ボタンを押してください。",
      resultDelayed:
        "結果の計算に通常より時間がかかっています。結果については管理者にお問い合わせください。",
      showResult: "結果を表示",
      redirectingToResult:
        "結果ページへ{{seconds}}秒後に自動遷移します。結果を表示ボタンを押さない場合に遷移します。",
      shareFeedbackTitle: "フィードバックを共有",
      shareFeedbackDescription:
        "あなたの意見が成長への道をつくります。一緒にレベルアップしましょう。",
      errorSubmittingFeedback: "フィードバックの送信に失敗しました",
      feedbackSubmittedTitle: "フィードバックの送信が完了しました！",
      feedbackSubmittedDescription:
        "フィードバックを送信いただきありがとうございます。{{featureName}}体験の改善にご協力感謝します。",
      feedbackAlreadySubmittedTitle: "フィードバックはすでに送信済みです！",
      feedbackAlreadySubmittedDescription:
        "すでにフィードバックは送信されています。{{featureName}}体験の改善にご協力感謝します。"
    },
    page: {
      errorFetchingPreAssessmentData: "事前評価データの取得エラー",
      connectionRestoredLabel: "接続が復旧しました。",
      connectionRestoredDescription: "最新の変更を同期しています...",
      offlineLabel: "オフラインのようです。",
      offlineDescription: "再接続するまで変更は同期されません"
    },
    question: {
      questions: "問題",
      closeQuestionsPanel: "問題パネルを閉じる",
      collapse: "折りたたむ",
      sectionSummary: "セクション概要",
      sections: "セクション",
      toggleQuestionsPanel: "問題パネルを切り替え",
      switchModal: {
        switchQuestionButton: "問題を切り替える",
        leaveHeading: "このまま離れてもよろしいですか？",
        discardMessage:
          "未保存の変更があります。問題を切り替えると、回答は完全に削除されます。",
        saveChangesButton: "変更を保存",
        saveHeading: "変更を保存しますか？",
        saveBeforeSwitchMessage:
          "未保存の変更があります。問題を切り替える前に保存しますか？"
      }
    },
    faq: {
      q1: {
        question: "{{featureName}}を始める前に何をすべきですか？",
        firstSentence: "次の準備が完了していることを確認してください。",
        list: {
          item1: "安定したインターネット接続",
          item2: "正常に動作するウェブカメラとマイク（ビデオ監督が有効な場合）",
          item3: "静かで気が散らない環境",
          item4:
            "ビデオ監督が有効な場合は、システムチェックの実施を求められます。",
          item5: "利用規約を読み、同意する"
        }
      },
      q2: {
        question: "{{featureName}}中に問題やセクションを移動できますか？",
        firstSentence: "移動可否は設定によって異なります。",
        list: {
          item1: "セクション移動が有効な場合は、セクション間を移動できます。",
          item2:
            "無効な場合は、次に進む前に1つのセクションを完了する必要があります。"
        },
        lastSentence: "説明は{{featureName}}中いつでも確認できます。"
      },
      q3: {
        question: "テスト中に監督されますか？",
        list: {
          item1:
            "この{{featureName}}でビデオ監督が有効な場合、カメラとマイクが使用されます。",
          item2: "異常な動作はレビューのために記録される場合があります。"
        }
      },
      q4: {
        question:
          "インターネット接続が切れたり、誤ってブラウザを閉じた場合はどうなりますか？",
        firstSentence: "進捗は自動的に保存されます。",
        lastSentence:
          "切断が発生した場合でも、同じリンクから{{featureName}}に再参加できます。"
      },
      q5: {
        question: "テスト後に結果やフィードバックを確認できますか？",
        firstSentence:
          "結果とフィードバックの表示は{{featureName}}の主催者設定によって決まります。",
        list: {
          item1:
            "有効な場合、提出後にスコアとフィードバック概要が表示されます。",
          item2: "無効な場合、結果は登録済みメールアドレスに共有されます。"
        }
      }
    },
    labels: {
      totalDuration: "総時間",
      numberOfQuestions: "問題数",
      numberOfSections: "セクション数",
      guidelines: "ガイドライン",
      platformHelp: "プラットフォームヘルプ",
      faq: "よくある質問",
      frequentlyAskedQuestions: "よくある質問",
      showFeatureInstructions: "{{featureName}}の説明を表示",
      minutes: "分",
      welcome: "ようこそ",
      welcomeBack: "お帰りなさい",
      userFallback: "ユーザー",
      defaultGuidelines:
        "{{featureName}}を開始する前に、静かで集中できる環境と安定したインターネット接続を確保してください。テスト中はカメラをオンのままにし、制限時間内で時間を適切に管理してください。技術的な問題が発生した場合はすぐにサポートへ連絡してください。提出前に回答を見直してください。健闘を祈ります。"
    },
    zoom: {
      textSize: "文字サイズ:",
      decreaseTextSize: "文字サイズを小さく (A-)",
      resetTextSize: "文字サイズをリセット (A)",
      increaseTextSize: "文字サイズを大きく (A+)",
      decreaseInterfaceSize: "表示サイズを小さく",
      resetInterfaceSize: "表示サイズをリセット",
      increaseInterfaceSize: "表示サイズを大きく"
    },
    wrapper: {
      warningTitle: "警告",
      stayOnPageMessage:
        "{{featureName}}を完了するまでこのページから離れないでください。",
      iUnderstand: "理解しました",
      submitTheFeature: "{{featureName}}を提出",
      videoProctoringInterrupted: "ビデオ監督が中断されました",
      continuationBlocked:
        "安全なビデオ監督が復旧するまで評価の続行はできません。",
      retryProctoring: "ビデオ監督を再試行"
    },
    progress: {
      proceed: "進む",
      resumeFeature: "{{featureName}}を再開",
      timeRemainingMessage:
        "{{featureName}}の残り時間です。下のボタンから中断した場所から再開してください。",
      continueOnThisDevice: "このデバイスで続行しますか？",
      switchToThisTab: "このタブに切り替えますか？",
      continueYourAssessmentHere: "ここで評価を続行しますか？",
      switchHere: "ここに切り替え",
      attemptsUnlimited: "この評価では無制限の試行回数が利用できます。",
      attemptsSingle: "この評価では<strong>1</strong>回の試行が利用できます。",
      attemptsMultiple:
        "この評価では<strong>{{maxAttempts}}</strong>回中<strong>{{remainingAttempts}}</strong>回の試行が利用できます。",
      coolOffAfterAttempt:
        "各試行後、次の試行を開始するまで<strong>{{coolOffTime}}</strong>待つ必要があります。"
    },
    loginWindow: {
      expiredTitle: "ログイン時間が終了しました",
      expiredMessage:
        "この{{featureName}}のログイン可能時間は終了しました。許可された時間内にアクセスできませんでした。"
    },
    coding: {
      saving: "保存中",
      offlineTitle: "オフラインのようです",
      offlineDescription: "再接続するまで変更は同期されません",
      connectionRestored: "接続が復旧しました",
      syncingLatest: "最新の変更を同期しています...",
      autoSaveEnabled: "自動保存が有効です",
      runOnlyChecksDescription:
        "は、テストケースに対するコードのチェックのみを行います。",
      submitEvaluationDescription:
        "をクリックすると、コードが評価されて得点が付与されます。",
      reset: "リセット",
      run: "実行",
      runTests: "テスト実行中",
      submit: "提出",
      submitting: "提出中",
      resetCode: "コードをリセット",
      resetCodeMessage:
        "リセットしてもよろしいですか？現在のコードは削除され、初期コードに戻ります。",
      testCases: "テストケース",
      testCase: "テストケース {{index}}",
      testCasePassed: "テストケース成功",
      testCaseFailed: "テストケース失敗",
      runtimeError: "実行時エラー",
      timeLimitExceeded: "時間制限超過",
      timeLimitExceededTitle: "時間制限を超えました",
      timeLimitExceededDescription:
        "コードが時間内に実行されませんでした。最適化してください。",
      input: "入力",
      expectedOutput: "期待される出力",
      yourOutput: "あなたの出力",
      hiddenTestCase: "非公開テストケース",
      hiddenTestCaseDescription:
        "非公開テストケースは、コーナーケースを含むさまざまなシナリオにコードが対応できるか評価するために使用されます。",
      explanation: "解説",
      hints: "ヒント"
    },
    subjective: {
      minWordsRequired: "回答を提出するには40語以上が必要です。",
      enterYourAnswer: "回答を入力してください",
      submitResponse: "回答を提出",
      submittingResponse: "回答を提出中...",
      resetAnswer: "回答をリセット",
      resetAnswerMessage:
        "リセットしてもよろしいですか？現在の回答は完全に削除されます。",
      retake: "再撮影",
      showHint: "ヒントを表示",
      recording: "録画中"
    },
    systemCheck: {
      calibrate: "キャリブレーション",
      calibrating: "キャリブレーション中...",
      accessDenied: "アクセス拒否",
      cameraPermissionDenied:
        "カメラの権限が拒否されました。続行するには、ブラウザ設定でカメラアクセスを有効にしてください。",
      errorFetchingDevices: "デバイスの取得中にエラーが発生しました",
      failedToStartAssessment: "評価の開始に失敗しました",
      unableToStartSecureProctoring:
        "現在、安全なプロクタリングを開始できません。再試行してください。",
      unnamedCamera: "名称未設定のカメラ",
      facingCalibrationIssues:
        "ビデオキャリブレーションで問題が発生していますか？",
      lookAtCenter: "画面の中央を見て、動かないでください。",
      unableToCalibrateTitle:
        "ビデオ監督のためのカメラキャリブレーションができませんか？",
      statusMessages: {
        readyForCalibration:
          "顔がはっきり見え、画面の中央にあることを確認してください。準備ができたら「キャリブレーション」をクリックして開始します。",
        calibratingInProgress:
          "キャリブレーション中です。画面を見続けてください。",
        calibratingTimedOut:
          "カメラのキャリブレーションがタイムアウトしました。続行するにはブラウザを更新してください。",
        preparingCameraPreview:
          "キャリブレーションのためにカメラストリームと顔追跡を準備しています。",
        retryRequired: "続行する前に、プロクタリング設定で対応が必要です。",
        proctoringUnavailable:
          "現在プロクタリングを利用できないため、評価を安全に開始できません。",
        calibrationCompleted:
          "キャリブレーションが完了しました。評価を開始する準備ができました。",
        timeoutHelp:
          "このメッセージが引き続き表示される場合は、カメラを使用中の他のタブ/アプリや外部シャッターを確認してください。"
      },
      failureReasons: {
        cameraPermissionDenied:
          "カメラ権限がブロックされています。アクセスを許可して再試行してください。",
        cameraUnavailable:
          "カメラを利用できません。デバイス選択を確認して再試行してください。",
        facemeshInitFailed:
          "顔追跡の初期化に失敗しました。続行するには再試行してください。",
        cocoLoadFailed:
          "プロクタリングエンジンを利用できません。更新してもう一度お試しください。",
        streamLostReacquireFailed:
          "カメラストリームの再取得に失敗しました。プロクタリングを再試行してください。",
        calibrationInsufficientData:
          "キャリブレーション用サンプルが不足していました。再度キャリブレーションしてください。",
        detectionCadenceUnavailable:
          "タイミング設定の準備ができていません。しばらくしてから再試行してください。"
      },
      calibrationInfo: {
        heading:
          "ビデオを正しくキャリブレーションするために、次の手順に従ってください。",
        followUpHeading:
          "それでも問題が発生する場合は、次の手順をお試しください。",
        initialSteps: {
          step1: {
            title: "十分な明るさを確保する",
            description:
              "顔がはっきり見える明るい場所に座ってください。背後に強い光や窓が来ないようにしてください。"
          },
          step2: {
            title: "カメラを正面から見る",
            description:
              "キャリブレーション中は顔をフレーム中央に置き、カメラをまっすぐ見てください。"
          },
          step3: {
            title: "暗い背景やぼやけた背景を避ける",
            description: "背景が明瞭で、暗すぎないことを確認してください。"
          },
          step4: {
            title: "カメラ権限を確認する",
            description:
              "求められた場合は、ブラウザにWebカメラへのアクセスを許可してください。"
          },
          step5: {
            title: "動かずに画面を見る",
            description:
              "キャリブレーション中は頭をできるだけ動かさず、システムが顔を正しく検出できるようにしてください。"
          }
        },
        laterSteps: {
          step1:
            "ページを更新して、カメラの再キャリブレーションをお試しください。",
          step2:
            "Webカメラを使用している他のアプリ（ZoomやTeamsなど）を閉じてください。",
          step3:
            "問題が続く場合は、エラーのスクリーンショットを添えて {{contactEmail}} までご連絡ください。"
        }
      }
    },
    stepper: {
      termsAndConditions: "利用規約",
      agreeTerms: "利用規約を読み、同意しました。",
      previousStep: "前のステップ",
      nextStep: "次のステップ",
      startAssessment: "評価を開始",
      resumeAssessment: "評価を再開",
      mediaCheck: "メディアチェック",
      systemCheck: "システムチェック",
      audioCheck: {
        intro:
          "ここで短い動画を録画して、カメラとマイクが正常に動作しているか確認できます。",
        mediaPermissionDenied:
          "カメラまたはマイクへのアクセスが拒否されました。ブラウザの設定で権限を有効にしてください。",
        startRecording: "録画を開始",
        stopRecording: "録画を停止",
        unnamedMicrophone: "名称未設定のマイク"
      },
      stepLabel: "ステップ {{step}}",
      personalDetails: "個人情報",
      emailId: "メールアドレス",
      firstName: "名",
      lastName: "姓",
      defaultTncStatement:
        "この評価に参加することにより、あなたは会社が定める参加要件を満たしていることを確認し、外部の支援を受けずにテストを独力で完了することに同意します。この評価はビデオ監督の対象であり、セッション中は気が散らない環境でカメラを常時オンにしておく必要があります。評価中に提供されるすべてのコンテンツおよび資料は機密情報であり、共有、複製、配布してはなりません。評価の指定時間内に受験することに同意し、期限までに提出できない場合は失格となる可能性があります。インターネット接続、ソフトウェア、ハードウェアに関する技術的な問題について、会社は責任を負いません。評価中に収集された個人データは、会社のプライバシーポリシーに従い、評価および採用目的にのみ使用されます。不正行為、盗用、またはその他の非倫理的行為を試みた場合、直ちに失格となります。回答を提出することにより、回答が最終であり、提出後に修正できないことを確認します。会社はこれらの条件をいつでも変更または更新する権利を有し、重要な変更がある場合は参加者に通知されます。",
      okay: "OK"
    },
    access: {
      cancelledTitle: "「{{title}}」はキャンセルされました",
      cancelledDescription:
        "この評価は現在無効でアクセスできません。割り当て済みまたは今後の評価をダッシュボードで確認してください。",
      goToHome: "ホームへ",
      refreshPage: "ページを再読み込み"
    },
    errorPage: {
      goBack: "戻る",
      raiseRequest: "リクエストを送信",
      retryLogin: "再ログイン",
      contactUs: "お問い合わせ",
      goBackToEvent: "イベントに戻る",
      launchCourse: "コースを開始",
      created: "作成日",
      starts: "開始",
      ends: "終了",
      untitled: "無題"
    },
    sidebar: {
      home: "ホーム",
      quickAccess: "クイックアクセス",
      questionPaperAuthoring: "問題用紙作成",
      assessmentLibrary: "評価ライブラリ",
      scheduleInterview: "面接をスケジュール",
      generateQuestions: "問題を生成",
      roleManagement: "ロール管理",
      logout: "ログアウト",
      noAccess: "アクセスなし",
      noAccessWithLabel: "{{label}}（アクセスなし）",
      noAccessToLink: "このリンクにアクセスする権限がありません",
      expandSidebar: "サイドバーを展開",
      collapseSidebar: "サイドバーを折りたたむ",
      expand: "展開",
      collapse: "折りたたむ",
      myPreferences: "マイ設定"
    },
    timesUp: {
      title: "試験時間が終了しました",
      autoSubmittedMessage:
        "時間切れです。回答は保存され、{{featureName}}は自動的に送信されました。"
    },
    resultCard: {
      title: "{{featureName}}の結果",
      score: "スコア",
      passPercentage: "合格率",
      marksAway:
        "認定まであと{{count}}点です。推奨分野を重点的に学習して再挑戦してください。",
      certificationEarned: "認定要件を上回り、認定を獲得しました。",
      congratulationsOnEarning:
        "{{featureName}} 認定の取得おめでとうございます",
      almostThereTitle: "認定取得まであと一歩です",
      certificatePassedDescription:
        "この認定を達成するために必要な知識とスキルを十分に示しました。この成果をぜひ祝い、あなたのネットワークにも共有してください。",
      certificateFailDescription:
        "今回の挑戦で、さらに強化すべきスキル領域が明確になりました。推奨分野を見直して、自信を持って再挑戦してください。",
      congratsImageAlt: "お祝い画像",
      almostThereImageAlt: "もう少し画像"
    },
    sectionCard: {
      section: "セクション",
      startSection: "セクションを開始",
      continueSection: "セクションを続行",
      completed: "完了",
      viewSection: "セクションを表示",
      totalQuestions: "総問題数:",
      sectionNotFound: "セクションが見つかりません。",
      total: "合計",
      flagged: "フラグ付き"
    },
    sectionSummary: {
      totalQuestions: "総問題数",
      completedQuestions: "完了問題数",
      flaggedQuestions: "フラグ付き問題数",
      unattemptedQuestions: "未挑戦問題数",
      codingQuestions: "コーディング問題:",
      objectiveQuestions: "客観式問題:",
      goToSections: "セクションに戻る",
      lowWordCountWarning:
        "質問 {{questionTitle}} の回答が40語未満です。セクションリストに戻るとこの回答は破棄されます。",
      videoNotSubmittedWarning:
        "質問 {{questionTitle}} の録画動画が未送信です。セクションリストに戻るとこの回答は破棄されます。"
    },
    objective: {
      questionCounter: "問題",
      marks: "点数 :",
      explanation: "解説",
      hints: "ヒント",
      reset: "リセット",
      flag: "フラグ",
      unflag: "フラグを外す",
      previous: "前へ",
      saveAndNext: "保存して次へ",
      saveAndViewSummary: "保存してセクションサマリーを表示",
      next: "次へ",
      viewSectionSummary: "セクションサマリーを表示",
      hideExplanation: "解説を隠す",
      showExplanation: "解説を表示",
      hintWaitTooltip: "次のヒントを見る前に少しお待ちください",
      noHintsPendingTooltip: "ヒントはこれ以上ありません",
      selectOptionForExplanation:
        "選択した選択肢の解説を表示するには選択肢を選んでください"
    },
    tour: {
      shared: {
        timer:
          "このタイマーは評価の残り時間を表示します。制限時間内にすべてのセクションを完了できるよう、こまめに確認してください。",
        submit:
          "評価のすべてのセクションを完了したら、'評価を提出' ボタンをクリックして提出できます。この操作により回答は確定され、提出後は変更できません。提出前にすべての回答を必ず確認してください。"
      },
      dashboard: {
        legend:
          "セクションのステータス凡例は、評価全体での進捗把握に役立ちます。未開始、進行中、完了を明確な表示で示すため、どの部分に対応が必要かを素早く判断し、時間を効率よく管理できます。",
        sectionCard:
          "セクションカードは各評価セクションの詳細を表示します。セクション名、現在の状態、そして質問に関する主要情報を確認できます。これには質問総数、フラグ付き質問数、完了した質問数が含まれます。進捗を把握し、重点的に対応すべき領域を見つけるのに役立ちます。"
      },
      coding: {
        titles:
          "ページ上部には評価タイトルとセクションタイトルが表示されます。これにより現在の作業内容を把握しやすくなり、どのセクションに取り組んでいるかを常に確認できます。質問間を移動する際の目印として活用してください。",
        sectionsButton:
          "このボタンを使うとセクションダッシュボードへ簡単に戻れます。評価全体の概要に戻り、すべてのセクションの進捗を確認・管理できます。現在の作業を失うことなく全体進捗を素早く見直せます。",
        sidebar:
          "サイドバーには現在のセクション内の全質問が一覧表示されます。該当ブロックを選択するだけで質問間を素早く移動できます。各質問ブロックは状態ごとに色分けされており、進捗管理や特定の質問への移動が容易です。",
        questionCard:
          "このカードには現在取り組んでいる質問が表示され、問題文全体と必要な指示・入力要件を確認できます。作業に必要な情報を分かりやすく提示し、スムーズに解答を進められるよう設計されています。後で見直すために質問をフラグするボタンも利用できます。さらに、サイドバーに戻らずに前後の質問へ移動できるナビゲーションボタンもあり、効率的に進行できます。",
        editor:
          "コードエディタは解答を記述・修正する場所です。各質問の要件に合わせてプログラミング言語を切り替えられます。作業しやすいようにエディタテーマの変更も可能です。より広い表示領域が必要な場合はフル幅に拡張できます。これらの機能により、コーディング課題を進める際に柔軟で使いやすい環境を提供します。"
      }
    },
    toast: {
      proctoringViolationDetected: "プロクタリング違反が検出されました",
      messages: {
        forbiddenObjectDetected: "禁止されている物体が検出されました",
        noFaceDetected: "顔が検出されませんでした",
        multipleFacesDetected: "複数の顔が検出されました",
        lookingAwayFromScreen: "画面から視線が外れています",
        notLookingAtScreen: "画面を見ていません",
        faceNotOrientedCorrectly: "顔の向きが正しくありません",
        eyesNotFullyOpen: "目が十分に開いていません",
        copyNotAllowed: "コピーは許可されていません",
        cutRestricted: "プロクタリングモードでは切り取りは制限されています",
        pasteNotAllowed: "貼り付けは許可されていません",
        contextMenuNotAllowed:
          "コンテキストメニューを開くことは許可されていません"
      }
    },
    whatsNext: {
      heading: "次にやること",
      attemptsRemaining: "残り試行回数",
      passed: {
        shareLinkedInTitle: "LinkedIn で共有",
        shareLinkedInSubtitle:
          "この成果をあなたのプロフェッショナルネットワークと共有しましょう。",
        viewCertificateTitle: "認定証を表示",
        viewCertificateSubtitle:
          "いつでも認定証をダウンロードまたは閲覧できます。",
        shareGloTitle: "経験を共有",
        shareGloSubtitle: "成果を社内共有して同僚に良い影響を与えましょう。"
      },
      failed: {
        reviewLearningResourcesTitle: "学習リソースを確認",
        reviewLearningResourcesSubtitle:
          "強化が必要なスキルに取り組みましょう。",
        retakeAssessmentTitle: "評価を再受験",
        retakeAssessmentSubtitle: "成長した理解と進歩を示しましょう。"
      },
      modal: {
        title: "成果を共有",
        linkedInPostLabel: "LinkedIn 投稿として共有",
        linkedInProfileLabel: "LinkedIn プロフィールに認定として追加",
        gloLabel: "Glo で共有",
        comingSoon: "近日公開",
        infoMessage: "共有するにはプラットフォームへのログインが必要です。"
      }
    },
    time: {
      hour_one: "{{count}} 時間",
      hour_other: "{{count}} 時間",
      minute_one: "{{count}} 分",
      minute_other: "{{count}} 分",
      hourShort: "時",
      minuteShort: "分",
      secondShort: "秒"
    },
    accessScreens: {
      attemptResultProcessing: {
        alt: "{{featureName}} の結果を処理中です",
        title: "結果を処理しています",
        description:
          "{{featureName}}を確認中です。しばらくしてからもう一度ご確認ください。"
      },
      coolOffPeriod: {
        alt: "クールオフ期間",
        title: "次の受験はまもなく可能です",
        completedAttempt: "この",
        nextAttemptIntro: "の受験はすでに完了しています。次の受験可能時刻まで"
      },
      maxAttemptExceeded: {
        alt: "最大受験回数に到達",
        title: "最大受験回数に達しました",
        description:
          "この{{featureName}}で利用可能な受験回数をすべて使い切りました。これ以上受験できません。"
      },
      scheduleNotStarted: {
        alt: "スケジュール未開始",
        title: "{{featureName}} はまだ開始されていません",
        scheduledPrefix: "",
        scheduledOn: "の開始予定時刻:",
        checkBack:
          "{{time}}後に再度確認するか、開始時刻になったら更新してください。"
      },
      scheduleTimeCompleted: {
        alt: "スケジュール時間終了",
        title: "{{featureName}} の受付時間は終了しました",
        description:
          "この{{featureName}}の予定時間は終了しました。受験の開始または提出はできません。"
      }
    },
    attemptDetails: {
      allAttempts: "すべての受験",
      headers: {
        attempt: "受験",
        attemptedOn: "受験日時",
        percentage: "割合"
      },
      viewAllAttempts: "すべての受験を見る"
    },
    survey: {
      questions: {
        q1: "1〜5の尺度で、{{featureName}}の問題の分かりやすさを評価してください。",
        q2: "{{featureName}}で扱われたトピックに対して十分に準備できていたと感じました",
        q3: "{{featureName}}で使用したプラットフォームは使いやすく機能的でした",
        q4: "私の回答は自分のスキルと知識を効果的に示せたと思います"
      },
      stronglyDisagree: "まったく同意しない",
      stronglyAgree: "強く同意する",
      submitFeedback: "フィードバックを送信"
    },
    cameraPreview: {
      loadingAlt: "カメラプレビューを読み込み中",
      delayedMessage:
        "ネットワークが遅いため、キャリブレーションに通常より時間がかかっています。しばらく待つか、ページを更新してください。"
    },
    proctoring: {
      engineLoadFailedStatus: "監督エンジンの読み込みに失敗しました",
      runtimeErrors: {
        cameraPermissionDenied:
          "ブラウザの権限設定によりカメラへのアクセスがブロックされています。",
        cameraUnavailable: "カメラが利用できないか、他のアプリで使用中です。",
        unableToLoadModel:
          "監督用オブジェクト検出モデルを読み込めませんでした。",
        webglRecoveryFailed:
          "オブジェクト検出の復元中にWebGLの回復に失敗しました。"
      },
      logs: {
        engineLoadFailed: "ProctoringEngine の読み込みに失敗:",
        videoPlayRejected: "Video play() が拒否されました:",
        cameraTrackEnded: "カメラトラックが終了 - 再取得を試行します",
        cameraReacquired: "試行 {{attempt}} でカメラを再取得しました",
        cameraReacquireAttemptFailed:
          "カメラ再取得の試行 {{attempt}} が失敗しました:",
        cameraReacquireFailedAll:
          "すべての試行後もカメラ再取得に失敗 - 各サイクルで cameraDisconnected を報告します",
        uploadFailedQueued:
          "監督アップロードが {{attempts}} 回失敗したため、再試行キューに追加します:",
        uploadAttemptFailedRetrying:
          "監督アップロード試行 {{attempt}} が失敗、再試行します...",
        drainedQueuedViolation:
          "キュー済み違反を送信: {{violationType}} (残り {{remaining}})",
        queueDrainFailed: "キュー送信に失敗。次サイクルで再試行します:",
        cocoLoadFailed: "COCO-SSD の読み込み失敗:",
        faceProcessingError: "顔処理エラー:",
        errorProcessingFrame: "フレーム処理エラー:",
        faceMeshInitError: "Face Mesh 初期化エラー:"
      }
    }
  }
} as const;

export default ja;
